
// src/pages/CustomerSegmentation.js
/* eslint-disable no-unused-vars */
import React, { useState, useContext, useEffect } from 'react';
import {
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  TextField,
  Button,
  InputAdornment,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Box,
  IconButton,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Modal
} from '@mui/material';
import { motion } from 'framer-motion';
import HorizontalStepper from '../components/HorizontalStepper';
import ProgressContext from '../context/ProgressContext';
import { UserContext } from '../context/UserContext';
import { useNavigate } from 'react-router-dom';
import BackButton from '../components/BackButton';
import axios from 'axios';
import DOMPurify from 'dompurify';
// ---------- icons ----------
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import WalletIcon from '@mui/icons-material/Wallet';
import TimerIcon from '@mui/icons-material/CalendarToday';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import DescriptionIcon from '@mui/icons-material/Description';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ArticleIcon from '@mui/icons-material/Article';
import ThumbDownAltOutlined from '@mui/icons-material/ThumbDownAltOutlined'
import ThumbUpAltOutlined from '@mui/icons-material/ThumbUpAltOutlined'

// ---------- collage images (put your 4 JPG/PNG files here) ----------
import Img1 from '../pages/images/SM679496.jpg';
import Img2 from '../pages/images/SM1072520.jpg';
import Img3 from '../pages/images/SM1089491.jpg';
import Img4 from '../pages/images/SM791163.jpg';

import apiClient from '../utils/apiClient';
import CryptoJS from 'crypto-js';

function CustomerSegmentation() {
  /* ------------ contexts & navigation ------------ */
  const { steps, setCurrentStep, goToStep } = useContext(ProgressContext);
  const { setUserNTID, setUserChannel, userNTID } = useContext(UserContext);

  const {
    productRecommendationFormData,
    setProductRecommendationFormData,
    segmentData,
    setSegmentData,
    setSegmentName,
    segmentName,
    customerName,
    setCustomerName,
    setPitchResponse,
    setSelectedProducts,
    setSelectedProductCodes,
    agentStrategyState,
    setAgentStrategyState,
    agentStrategy,
    setAgentStrategy,
  } = useContext(UserContext);
  const navigate = useNavigate();
  /* ------------ local component states ------------ */
  const [formData, setFormData] = useState(
     {
      customerName: '',
      customerAge: '',
      gender: 'Male',
      customerIncome: '',
    }
  );
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  // manual‑flow states
  const [showManualOptions, setShowManualOptions] = useState(false);
  const [productList, setProductList] = useState([]);
  const [selectedProductsLocal, setSelectedProductsLocal] = useState([]);
  const [manualLoading, setManualLoading] = useState(false);
  const [processingManual, setProcessingManual] = useState(false);
  // product‑card states
  const [expandedCardIndex, setExpandedCardIndex] = useState(null);
  /* ------------ initialise step index ------------ */

  useEffect(() => {
    const idx = steps.findIndex(
      (s) => s.path === '/dashboard/customer-segmentation'
    );
    if (idx !== -1) setCurrentStep(idx);
  }, [steps, setCurrentStep]);
  /* ------------ persist form data in UserContext ------------ */
  useEffect(() => {
    console.log()
    if(localStorage.getItem('location_history')=='customer_segmentation_commited' ){

      console.log("debug1")
      setFormData(JSON.parse(localStorage.getItem('formDataSegmentation_history')))
      console.log("debug22222", formData)
      let segment_data = JSON.parse(localStorage.getItem('segmentdata_history'))
      console.log("debug333333", segment_data)
      setSegmentData(segment_data);
      setSegmentName(segment_data.segment);
      setCustomerName(segment_data.customer_name);
      // scrollToSection("segment_information", 60)
      handleManual(segment_data.segment)
      localStorage.removeItem('location_history')
     
    }

  // }, [formData, setProductRecommendationFormData, segmentData, segmentName, customerName]);
  }, []);


  useEffect(() => {
    const savedState = localStorage.getItem(
      "customerSegmentationState"
    );
    
    if (savedState) {
      const state = JSON.parse(savedState);
      if (state.formData) {
         setFormData(state.formData);
      }
      if (state.segmentData) {
         setSegmentData(state.segmentData);
         setSegmentName(state.segmentData.segment);
         setCustomerName(state.segmentData.customer_name);
      }
      setSelectedProductsLocal(
         state.selectedProductsLocal || []
      );
      setShowManualOptions(
         state.showManualOptions || false
      );
      if (
         state.showManualOptions &&
         state.segmentData?.segment
      ) {
         handleManual(state.segmentData.segment);
      }
      localStorage.removeItem("customerSegmentationState");
    }
   }, []);
  // useEffect(() => {
  //    const handlePopState = () => window.history.pushState(null, "", window.location.href);
  //    window.history.pushState(null, "", window.location.href);
  //    window.addEventListener("popstate", handlePopState);
  //    return () => window.removeEventListener("popstate", handlePopState);
  // }, []);
  
const scrollToSection = (id, offset)=>{
    var element = document.getElementById(id);
    var elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    var offsetPosition = elementPosition - offset;

    window.scrollTo({
        top: offsetPosition,
        behavior:"smooth"
    })
}  
  /* ================== helpers / handlers ================== */
  const calculateSegment = async () => {
    localStorage.setItem('location_history','customer_segmentation')
    localStorage.setItem('formDataSegmentation_history', JSON.stringify(formData))
    if (!formData.customerName || !formData.customerAge || !formData.customerIncome) {
      setError('Please fill in all fields');
      return;
    }
    setError('');
    setLoading(true);
    try {
      console.log({
          customer_name: formData.customerName,
          customer_income: +formData.customerIncome,
          customer_age: +formData.customerAge,
          gender: formData.gender,
          ntID: userNTID
        })
      const { data } = await apiClient.post(
        '/customer-segmentation',
        {
          customer_name: formData.customerName,
          customer_income: +formData.customerIncome,
          customer_age: +formData.customerAge,
          gender: formData.gender,
          ntID: userNTID
        },
        { withCredentials: true }
      );
      console.log(data)
      localStorage.setItem('segmentdata_history', JSON.stringify(data))
      setSegmentData(data);
      setSegmentName(data.segment);
      setCustomerName(data.customer_name);
      scrollToSection("segment_information", 60)

    } catch (e) {
      setError(
        e.response?.data?.detail ||
          'An error occurred while calculating the segment'
      );
    } finally {
      setLoading(false);
    }
  };
  /* ----- path A – customer‑specific recommendations ----- */
  const handleCustomerSpecific = () => {
    const updatedStrategy = {
      ...agentStrategyState,
      strategy: '1',
      recommendationType: '1.3',
      productOption: 'All',
      selectedProducts: [],
    };
    setAgentStrategyState(updatedStrategy);
    setAgentStrategy({
      ...agentStrategy,
      strategy: '1',
      recommendation_type: '1.3',
      recommendationType: '1.3',
      product_option: 'All',
      selected_products: [],
    });
    navigate('/dashboard/product-recommendation?type=1.3');
  };
  /* ----- path B – manual recommendations ----- */
  const handleManual = async ( segmentOverride = null) => {
    const updatedStrategy = {
      ...agentStrategyState,
      strategy: '2',
      recommendationType: '',
      productOption: 'Selected',
      selectedProducts: [],
    };
    setAgentStrategyState(updatedStrategy);
    setAgentStrategy({
      ...agentStrategy,
      strategy: '2',
      recommendation_type: null,
      recommendationType: null,
      product_option: 'Selected',
      selected_products: [],
    });
    setShowManualOptions(true);

    const segmentNameToUse = segmentOverride || segmentData?.segment;

    if (segmentNameToUse) {
      setManualLoading(true);
      try {
        const { data } = await apiClient.post('/filtered-segment-data', 
          { ntID: userNTID, 
            segmentName: segmentNameToUse },
          {
            // params: { segment_name: segmentData.segment },
            withCredentials: true,
          }
        );
        const names = data.filtered_segment_data.map((d) => d['Product Name']);
        setProductList(names);
      } catch (err) {
        console.error('Error fetching filtered segment data:', err);
      } finally {
        setManualLoading(false);
      }
    }
  };
  const handleManualBack = () => {
    setShowManualOptions(false);
    // setSelectedProductsLocal([]);
  };

  const handleManualProceed = async () => {
    if (selectedProductsLocal.length === 0) {
      alert('Please select at least one product');
      return;
    }
    setProcessingManual(true);
    try {
      const { data } = await apiClient.post(
        '/manual-product-pitch',
        {
          agent_strategy: {
            strategy: '2',
            product_option: 'Selected',
            selected_products: selectedProductsLocal,
          },
          segment_name: segmentData.segment,
          ntID: userNTID,
        },
        { withCredentials: true }
      );
      setPitchResponse(data.pitch_response);
      setSelectedProducts(selectedProductsLocal);
      setSelectedProductCodes(data.selected_product_codes);
      setAgentStrategy((prev) => ({
        ...prev,
        strategy: '2',
        product_option: 'Selected',
        selected_products: selectedProductsLocal,
      }));
      setAgentStrategyState((prev) => ({
        ...prev,
        strategy: '2',
        productOption: 'Selected',
        selectedProducts: selectedProductsLocal,
      }));
      goToStep(2);
      navigate('/dashboard/ebi-generation');
    } catch (err) {
      console.error('Error generating manual pitch:', err);
    } finally {
      setProcessingManual(false);
    }
  };
  /* ---------- product‑card helpers ---------- */
  const toggleCardExpand = (index) =>
    setExpandedCardIndex(expandedCardIndex === index ? null : index);
  const openPopup = (url, name = 'popup', w = 800, h = 600) => {
    if (!url) return;
    const left = (window.screen.width - w) / 2;
    const top = (window.screen.height - h) / 2;
    window.open(url, name, `width=${w},height=${h},top=${top},left=${left}`);
  };
  const getIconForLabel = (label) => {
    switch (label) {
      case 'brochure':
        return <DescriptionIcon />;
      case 'product_ppt':
        return <PictureAsPdfIcon />;
      case 'terms_and_conditions':
        return <InsertDriveFileIcon />;
      case 'one_pager':
        return <ArticleIcon />;
      default:
        return null;
    }
  };
  // const productSelected = (idx)=>{
  //   console.log("nirmalya====",idx)
    
  //   if(selectedProductsLocal.includes(idx)){
  //     console.log("removal triggered")
  //     setSelectedProductsLocal([])
  //     document.getElementById("id_for_"+idx).style.border = '0px solid red'
  //   }else{
  //     console.log("addtion triggered")
  //     selectedProductsLocal.forEach((ide)=>{
  //     document.getElementById("id_for_"+ide).style.border = '0px solid red'
  //     })
  //     document.getElementById("id_for_"+idx).style.border = '0px solid red'
  //     setSelectedProductsLocal([idx]);
  //   }
  //   console.log("manual_product_checkbox_"+idx)
  // }
  const productSelected = (idx) => {
    if (selectedProductsLocal.includes(idx)) {
      setSelectedProductsLocal([]);
    } else {
      setSelectedProductsLocal([idx]);
    }
  };

  const handleCheckboxChange = (e) => {

    const { value } = e.target;
    setSelectedProductsLocal((prev) =>
      prev.includes(value) ? prev.filter((p) => p !== value) : [...prev, value]
    );
  };
    const [feedback_open, setFeedback_open] = useState(0)
  const FeedbackPopupClose = () =>{
    setFeedback_open(0)
  }
  const CLIENT_ID = process.env.REACT_APP_LOGINASSISTANT_HASH;
  // EXACT encryption logic you provided:
  function encryptAES(plainText) {
    const key = CryptoJS.enc.Utf8.parse(CLIENT_ID);
    // Last 16 characters for IV
    const ivString = CLIENT_ID.slice(-16);
    const iv = CryptoJS.enc.Utf8.parse(ivString);
    const encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(plainText),
      key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return encrypted.toString(); // Base64
  }
  
    const getUniqueValFromProduct = (product_id) => {
    const newUniqueValue = Math.floor(Math.random() * 900000 + 100000).toString();
    return newUniqueValue
  }
const products = [
  { "product_id": 1, "product_code": "E11" },
  { "product_id": 2, "product_code": "E34" },
  { "product_id": 3, "product_code": "E28" },
  { "product_id": 4, "product_code": "E11" },
  { "product_id": 5, "product_code": "E34" },
  { "product_id": 6, "product_code": "E28" },
  { "product_id": 7, "product_code": "E28" },
  { "product_id": 8, "product_code": "E35" },
  { "product_id": 9, "product_code": "E36" },
  { "product_id": 10, "product_code": "UW2" },
  { "product_id": 11, "product_code": "UW5" },
  { "product_id": 12, "product_code": "E36" },
  { "product_id": 13, "product_code": "UW2" },
  { "product_id": 14, "product_code": "UW6" },
  { "product_id": 15, "product_code": "UW5" },
  { "product_id": 16, "product_code": "E35" },
  { "product_id": 17, "product_code": "I19" },
  { "product_id": 18, "product_code": "GPP" },
  { "product_id": 19, "product_code": "E36" },
  { "product_id": 20, "product_code": "UW2" },
  { "product_id": 21, "product_code": "E36" },
  { "product_id": 22, "product_code": "E35" },
  { "product_id": 23, "product_code": "UW2" },
  { "product_id": 24, "product_code": "I19" },
  { "product_id": 25, "product_code": "UW6" },
  { "product_id": 26, "product_code": "UW5" },
  { "product_id": 27, "product_code": "GPP" },
  { "product_id": 28, "product_code": "I16" },
  { "product_id": 29, "product_code": "UB8" },
  { "product_id": 30, "product_code": "UB8" },
  { "product_id": 31, "product_code": "UB8" },
  { "product_id": 32, "product_code": "UB8" },
  { "product_id": 33, "product_code": "E36" },
  { "product_id": 34, "product_code": "E38" },
  { "product_id": 35, "product_code": "E38" },
  { "product_id": 36, "product_code": "UB9" },
  { "product_id": 37, "product_code": "UB9" },
  { "product_id": 38, "product_code": "UW9" }
];


  const getProductCode = (id) => {
    const product = products.find(p => p.product_id == id);
    return product ? product.product_code : "Product not found";
  }
 
  const openLoginAssistant = (product_id)=>{
    localStorage.setItem('location_history','customer_segmentation')      
      product_id = selectedProductsLocal[0]
      console.log("nirmalya=====",product_id)
    let product_code = getProductCode(product_id)
    console.log("nirmalya=====", product_code)
    // The external system wants "DILI" + <uniqueVal> as the raw session_id
    const rawSessionId = 'DILI' + getUniqueValFromProduct(product_code); // e.g. DILI123456
    console.log("rawSessionid ==== ", rawSessionId)
    const encrypted = encryptAES(rawSessionId);
    // Example iFrame URL:
    // http://buyuat.iprulifeinsurance.com/digiuatnew/EBI.htm#/LAEBI/<productCode>?value=<encrypted>
    // const baseUrl = 'https://buyuat.iprulifeinsurance.com/digiuatnew/EBI.htm#/LAEBI';
    const baseUrl = 'https://buy.iciciprulife.com/buy/EBI.htm#/LAEBI';

    // const baseUrl="http://localhost:3000"
    // return baseUrl    
    // window.open(`${baseUrl}/${product_code}?value=${encodeURIComponent(encrypted)}`,'_blank');
    localStorage.setItem(
      "customerSegmentationState",
      JSON.stringify({
        formData,
        segmentData,
        selectedProductsLocal,
        showManualOptions
      })
    )
    window.location.href = `${baseUrl}/${product_code}?value=${encodeURIComponent(encrypted)}`
  }

  const onField = k => (e, v) => {  setFormData({ ...formData, [k]: typeof v !== 'undefined' ? v : e.target.value }) };
  const onFieldSelect = k => e => {  
    setFormData({ ...formData, [k]: e.target.value }) 
  };

  /* ========================= JSX ========================= */
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 6 }}>
      <HorizontalStepper />
      {/* hero copy */}
      <Typography
        variant="h2"
        sx={{
          textAlign: 'center',
          fontWeight: 700,
          fontSize:{ xs: '1.0rem', sm:'1.5rem', md:'2rem' },
          background:'linear-gradient(90deg,#89001b 0%,#c00026 25%,#ff5400 60%,#ff7528 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          // display:'inline-block',
          mb: 4,
          // color: 'secondary.main',
        }}
      >
        Start with knowing your customer.
        <br />
        {/* <Box component="span" sx={{ color: 'primary.main' }}> */}
        Simplify your sales journey.
        {/* </Box> */}
      </Typography>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        {/* ------------- collage + form ------------- */}
        <Grid
          container
          spacing={{ xs: 2, md: 4 }}
          alignItems="stretch"
          justifyContent="center"
        >
          {/* collage */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={1} sx={{ height: '100%' }}>
              {[Img1, Img2, Img3, Img4].map((src, idx) => (
                <Grid
                  item
                  xs={6}
                  key={idx}
                  sx={{
                    height: { xs: 120, sm: 160, md: 180 },
                    overflow: 'hidden',
                    borderRadius: 3,
                  }}
                >
                  <Box
                    component="img"
                    src={src}
                    alt={`seg-${idx}`}
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      transition: 'transform .4s',
                      '&:hover': { transform: 'scale(1.507)' },
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
          {/* form card */}
          <Grid item xs={12} md={6}>
            <Card
              elevation={0}
              sx={{
                background: 'rgba(255,241,224,.6)',
                backdropFilter: 'blur(8px)',
                p: { xs: 2, sm: 3 },
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <CardContent sx={{ p: 0 }}>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 700, mb: 3, color: 'secondary.dark' }}
                >
                  Customer Details
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Customer Name"
                      value={formData.customerName}
                      onChange={onField('customerName')}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AccountCircleIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Age (years)"
                      type="number"
                      value={formData.customerAge}
                      onChange={onField('customerAge')}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <TimerIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Annual Income (INR)"
                      type="number"
                      value={formData.customerIncome}
                      onChange={onField('customerIncome')}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <WalletIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <InputLabel>Gender</InputLabel>
                      <Select
                        value={formData.gender}
                        label="Gender"
                      onChange={onFieldSelect('gender')}
                      >
                        <MenuItem value="Male">Male</MenuItem>
                        <MenuItem value="Female">Female</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                {error && (
                  <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                    {error}
                  </Typography>
                )}
              </CardContent>
              <Button
                variant="contained"
                size="large"
                sx={{ mt: 3, alignSelf: 'center', minWidth: 180 }}
                onClick={calculateSegment}
                disabled={loading}
              >
                {loading ? 'Calculating…' : 'Submit'}
              </Button>
            </Card>
          </Grid>
        </Grid>
      </motion.div>
      {/* ---------------- downstream UI (unchanged logic) ---------------- */}
      {segmentData && (
        <>
          <Typography
            variant="h6"
            id = "segment_information"
            sx={{
              textAlign: 'center',
              fontWeight: 600,
              mt: 6,
              mb: 2,
              fontSize: { xs: '1rem', sm: '2.2rem' }, // smaller than h3 but responsive
              color: 'secondary.main',
            }}
          >
            Identified Customer Segment:{' '}

            <Box component="span" sx={{ color: 'primary.main' }}>
              {segmentData.segment_display_name || segmentData.segment}
            </Box>

          </Typography>
          {!showManualOptions && (
            <Box sx={{ display: 'flex', gap: 2, mt: 3, mb: 3, flexWrap: 'wrap' }}>
              <Button
                variant="contained"
                color="primary"
                sx={{ flex: 1, minWidth: 220 }}
                onClick={handleCustomerSpecific}
              >
                Customzied Product Solution
              </Button>
              <Button
                variant="contained"
                color="secondary"
                sx={{ flex: 1, minWidth: 220 }}
                onClick={handleManual}
              >
                Top Suited Products
              </Button>
            </Box>
          )}

          {/* product reference cards */}
          {segmentData.products?.length > 0 && (
            <Box sx={{ mb: 6 }}>
          {showManualOptions && (   
            <>          
              <Typography variant="subtitle1" gutterBottom>
                Product Details
              </Typography>

              <Grid container spacing={2}>

                {segmentData.products.map((prod, idx) => {
                  const expanded = expandedCardIndex === idx;
                  return (
                    <Grid item xs={12} sm={6} md={6} key={idx}>
                      {/* <Card
                        id = {"id_for_"+prod.product_id}
                        sx={{
                          position: 'relative',
                          transition: 'all .45s',
                          p: 2,
                          borderRadius: 2,
                          height: 'auto' ,
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'flex-start',
                        }}
                      > */}
                      <Card
                        id={"id_for_"+prod.product_id}
                        sx={{
                          position: 'relative',
                          transition: 'all .45s',
                          p: 2,
                          borderRadius: 2,
                          height: 'auto',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'flex-start',
                          border: selectedProductsLocal.includes(prod.product_id)
                            ? '2px solid red'
                            : '1px solid #e0e0e0'
                        }}
                      >
                        {/* condensed view */}
                        {!expanded && (
                          <>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                              }}
                            >
                                  <Checkbox
                                    checked={selectedProductsLocal.includes(prod.product_id)}
                                    onChange={()=>productSelected(prod.product_id)}
                                    />

                              <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                {prod.product_logo && (
                                  <Box
                                    component="img"
                                    src={prod.product_logo}
                                    alt={prod.product_name}
                                    sx={{
                                      width: 50,
                                      height: 50,
                                      mr: 1,
                                      objectFit: 'contain',
                                    }}
                                  />
                                )}
                                <Box>

                                  <Typography variant="subtitle1" fontWeight={700}>
                                    {prod.product_name}
                                  </Typography>
                                  <Typography variant="body2">
                                    {prod.product_category} | {prod.product_filter}
                                  </Typography>
                                </Box>
                              </Box>
                              <IconButton onClick={() => toggleCardExpand(idx)}>
                                <ArrowForwardIosIcon />
                              </IconButton>
                            </Box>
                            <Box sx={{ borderBottom: '1px solid #ccc', my: 1 }} />
                            {prod.key_features?.length > 0 && (
                              <>
                              <ul style={{ paddingLeft: '1.2em' }}>
                                {prod.key_features.map((kf, kidx) => (
                                  <li key={kidx} style={{ marginBottom: 4 }}>
                                    <CheckCircleIcon
                                      sx={{ color: 'green', fontSize: 16, mr:0.5, mb: '-2px' }}
                                    />
                                    {kf.feature}
                                  </li>
                                ))}
                              </ul>
                                                            </>
                              
                            )}
                          </>
                        )}
                        {/* expanded view */}
                        {expanded && (
                          <>
                            <IconButton
                              onClick={() => toggleCardExpand(idx)}
                              sx={{ position: 'absolute', top: 8, left: 8 }}
                            >
                              <ArrowBackIosIcon fontSize="small" />
                            </IconButton>
                            <Grid container spacing={2} sx={{ mt: 4 }}>
                              <Grid item xs={12} sm={4}>
                                {prod.details_screen_image && (
                                  <Box
                                    component="img"
                                    src={prod.details_screen_image}
                                    alt={prod.product_name}
                                    sx={{ width: '100%', objectFit: 'contain' }}
                                  />
                                )}
                              </Grid>
                              <Grid item xs={12} sm={8}>
                                {/* download links */}
                                <Grid container spacing={1} sx={{ mb: 2 }}>
                                  {[
                                    { label: 'brochure', url: prod.brochure },
                                    { label: 'product_ppt', url: prod.product_ppt },
                                    { label: 'terms_and_conditions', url: prod.terms_and_conditions },
                                    { label: 'one_pager', url: prod.one_pager },
                                  ].map(
                                    (d, i) =>
                                      d.url && (
                                        <Grid item key={i}>
                                          <Button
                                            variant="outlined"
                                            size="small"
                                            startIcon={getIconForLabel(d.label)}
                                            onClick={() => openPopup(d.url, '_blank')}
                                          >
                                            {d.label.toUpperCase()}
                                          </Button>
                                        </Grid>
                                      )
                                  )}
                                </Grid>
                                {/* 30‑sec pitch */}
                                {prod.thirty_seconds_pitch && (
                                  <Typography
                                    variant="body2"
                                    sx={{ mb: 2 }}
                                    dangerouslySetInnerHTML={{
                                      __html: DOMPurify.sanitize(prod.thirty_seconds_pitch),
                                    }}
                                  />
                                )}
                                {prod.comparing_returns_url && (
                                  <Button
                                    variant="text"
                                    sx={{ mb: 2, textTransform: 'none' }}
                                    onClick={() => openPopup(prod.comparing_returns_url, '_blank')}
                                  >
                                    Compare Returns
                                  </Button>
                                )}
                                {/* videos */}
                                {prod.videos?.map(
                                  (v, vidIdx) =>
                                    v.video_status === 'Active' && (
                                      <Box
                                        key={vidIdx}
                                        sx={{ display: 'flex', alignItems: 'center', mb: 2 }}
                                      >
                                        {v.videoThumbnailImage && (
                                          <Box
                                            component="img"
                                            src={v.videoThumbnailImage}
                                            alt="thumb"
                                            sx={{
                                              width: 100,
                                              mr: 1,
                                              cursor: 'pointer',
                                            }}
                                            onClick={() => openPopup(v.videoLink, 'videoPopup')}
                                          />
                                        )}
                                        <IconButton
                                          onClick={() => openPopup(v.videoLink, 'videoPopup')}
                                        >
                                          <PlayCircleIcon color="primary"kbilnds/>
                                        </IconButton>
                                      </Box>
                                    )
                                )}
                              </Grid>
                            </Grid>
                          </>
                        )}
                      </Card>
                    </Grid>
                  );
                })}

              </Grid>


                           <center>
                <Button variant="outlined" onClick={handleManualBack} sx={{float:'left', mt:2}}> 
                  Back
                </Button>

              <Button
                variant="contained"
                sx={{ mt: 2 , float: 'right'}}
                disabled={processingManual || selectedProductsLocal.length === 0}
                onClick={openLoginAssistant}
                
              >
                Open Login Assistant

              </Button>
              </center><br/><br/>

              </> 
 
 )}
 
                        {/* manual‑selection panel */}
            </Box>
          )}
        </>
      )}
    </Container>
  );
}
export default CustomerSegmentation;
